module.exports = __webpack_public_path__ + "static/img/fruit_bra_2.c7d1f1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/compressed/drawing_painting/fruit_bra_2.jpg
// module id = VtZq
// module chunks = 1